import * as React from 'react';
import CreateCustomViewLink from './CreateCustomViewLink';
import CustomViewsUpgradeLink from './CustomViewsUpgradeLink';
import { getUserHasCustomViewsAccess } from '../../selectors/userSelectors/getUserHasCustomViewsAccess';
import { getUserIsSuperAdmin } from '../../selectors/userSelectors/getUserIsSuperAdmin';
import { useSelector } from 'react-redux';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomViewsFooterLink = ({
  onCreateCustomViewClick,
  openUpgradeModal
}) => {
  const hasCustomViewsAccess = useSelector(getUserHasCustomViewsAccess);
  const userIsSuperAdmin = useSelector(getUserIsSuperAdmin);

  // disable custom view creation on portal 53 only
  if (PortalIdParser.get() === 53) {
    return null;
  }
  if (hasCustomViewsAccess === true) return /*#__PURE__*/_jsx(CreateCustomViewLink, {
    onCreateCustomViewClick: onCreateCustomViewClick
  });
  if (hasCustomViewsAccess === false && userIsSuperAdmin === true) return /*#__PURE__*/_jsx(CustomViewsUpgradeLink, {
    openUpgradeModal: openUpgradeModal
  });
  return null;
};
CustomViewsFooterLink.displayName = 'CustomViewsFooterLink';
export default CustomViewsFooterLink;